import { render } from "./AboutHubsynch.vue?vue&type=template&id=8e06f9d6"
import script from "./AboutHubsynch.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutHubsynch.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/AboutHubsynch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e06f9d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e06f9d6', __exports__)) {
    api.reload('8e06f9d6', __exports__)
  }
  
  module.hot.accept("./AboutHubsynch.vue?vue&type=template&id=8e06f9d6", () => {
    api.rerender('8e06f9d6', render)
  })

}


export default __exports__